import { FieldError, Merge } from "react-hook-form"
import styled from "styled-components"
import { Box } from "../elements/Box"
import { ErrorSpan } from "./ErrorSpan"

interface ICheckboxGroupProps {
  children: React.ReactNode
  error?: Merge<FieldError, (FieldError | undefined)[]> | FieldError
}

const StyledCheckboxGroup = styled.div`
  background-color: ${(props) => props.theme.colors.boxBackground};
  padding: clamp(1rem, 0.8rem + 1vw, 2rem) clamp(1.25rem, 1rem + 1.25vw, 2.5rem);
  border: 1px solid ${(props) => props.theme.colors.border};

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: clamp(1rem, 0.8rem + 1vw, 2rem);
  box-sizing: border-box;
  width: 100%;
`

const CheckboxGroup = (props: ICheckboxGroupProps) => {
  const { children, error } = props
  return (
    <Box
      flexDirection="column"
      gapInRem={0.5}
      alignItems="flex-start"
      fullwidth
    >
      <StyledCheckboxGroup>{children}</StyledCheckboxGroup>
      {error && <ErrorSpan>{error.message}</ErrorSpan>}
    </Box>
  )
}

export { CheckboxGroup }
